import { render, staticRenderFns } from "./WeekRange.vue?vue&type=template&id=1d3fff61"
import script from "./WeekRange.vue?vue&type=script&lang=js"
export * from "./WeekRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports